import React, { useState } from 'react';
import NewModal from '../../../../Shared/NewModal';
import { Tab, Tabs, Box } from '@mui/material';
import MedicationStatusDetails from './MedicationStatusDetails';
import MedicationUsageDetails from './MedicationUsageDetails';
import { MedicationDescriptionDetails } from './MedicationDescriptionDetails';
import { MedicationNotes } from './MedicationNotes';
import { MedicationListItem } from '../../../../../store/hubOwner/types';
import { dimGrey, lightBlack, lightTeal } from '../../../../../mainTheme';

const tabStyles = {
  indicator: {
    backgroundColor: lightTeal,
  },
  tab: {
    textTransform: 'none',
    fontWeight: 700,
    fontSize: '14px',
    color: dimGrey,
    lineHeight: '20px',
    letterSpacing: '0.2px',
  },
  selected: {
    color: `${lightBlack} !important`,
  },
};

interface MedicationDetailModalProps {
  onClose: () => void;
  rowData: MedicationListItem | null;
  patientId: number;
}

const MedicationDetailModal: React.FC<MedicationDetailModalProps> = ({
  onClose,
  rowData,
  patientId,
}) => {
  const [activeTab, setActiveTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setActiveTab(newValue);
  };

  const tabLabels = ['Status', 'Usage', 'Description', 'Notes'];

  const renderTabContent = () => {
    switch (activeTab) {
      case 0:
        return (
          <MedicationStatusDetails rowData={rowData} patientId={patientId} />
        );
      case 1:
        return <MedicationUsageDetails rowData={rowData} />;
      case 2:
        return <MedicationDescriptionDetails rowData={rowData} />;
      case 3:
        return <MedicationNotes rowData={rowData} patientId={patientId} />;
      default:
        return (
          <MedicationStatusDetails rowData={rowData} patientId={patientId} />
        );
    }
  };

  return (
    <NewModal
      showCloseX
      title={rowData?.name || 'Medication Details'}
      onClose={onClose}
      maxWidth="sm"
      contentPaddingTop="0px"
    >
      <Tabs
        value={activeTab}
        onChange={handleTabChange}
        variant="scrollable"
        scrollButtons="auto"
        sx={{
          '& .MuiTabs-indicator': tabStyles.indicator,
          '& .MuiTab-root': tabStyles.tab,
          '& .Mui-selected': tabStyles.selected,
        }}
      >
        {tabLabels.map((label) => (
          <Tab key={label} label={label} />
        ))}
      </Tabs>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }} />
      {renderTabContent()}
    </NewModal>
  );
};

export default MedicationDetailModal;
